import React, { ComponentType } from 'react';
import { useLocation, useNavigate, useParams, Location, Params } from 'react-router-dom';

export interface RouterProps {
    router: {
        location: Location;
        navigate: ReturnType<typeof useNavigate>;
        params: Params;
    }
}

const withRouter = <P extends RouterProps>(Component: ComponentType<P>) => {
    function ComponentWithRouterProp(props: Omit<P, keyof RouterProps>) {
        const location = useLocation();
        const navigate = useNavigate();
        const params = useParams();

    return (
        <Component
            {...(props as P)}
            router={{ location, navigate, params }}
        />
    );
}

    return ComponentWithRouterProp;
};

export default withRouter;
